import React, { useState, useRef } from "react";
import ControldocFormTemplateLayoutForm from "../../../controldoc_form/template_layout/form";
import {
  create as createTemplateLayout,
  update as updateTemplateLayout,
  preview as previewTemplateLayout
} from "./axios";

const LaboralControldocFormTemplateLayoutForm = props => {
  return(
    <ControldocFormTemplateLayoutForm
      templateLayout={ props?.templateLayout || {} }
      imagePicker={ props?.imagePicker }
      configuration={{
        formName: 'laboral_controldoc_form_template_layout',
        context: 'laboral'
      }}
      actions={{
        createTemplateLayout: createTemplateLayout,
        updateTemplateLayout: updateTemplateLayout,
        previewTemplateLayout: previewTemplateLayout,
        showTemplateLayoutPath: Routes.laboral_controldoc_form_template_layout_path,
        indexTemplateLayoutPath: Routes.laboral_controldoc_form_template_layouts_path
      }}
    />
  )
}

export default LaboralControldocFormTemplateLayoutForm;
